<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="vc_gb" label="国别" required>
                <el-select :disabled="canEdit" style="width: 200px" @change="changegb"  class="marr4" v-model="formData.i_gbid" size="small" clearable filterable placeholder="请选择国别">
                    <el-option v-for="item in gblist" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="vc_Cname" label="中文名称" required>
                <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_Cname"  ></el-input>
            </el-form-item>
            <el-form-item  prop="vc_Ename" label="英文名称" required>
                <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_Ename"  ></el-input>
            </el-form-item>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >保存</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            </template>
            <el-button @click="cancel" size="small">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                gblist:[],
                i_id:0,
                formData:{},
                baseerp:'',
                canEdit:false,
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(this.i_id==0){
                            this.canEdit=false;
                            this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");
                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data));
                            this.canEdit=true;
                        }
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            saveForm(){
                if(this.formData.i_khid==''||this.formData.i_khid==undefined||this.formData.i_gsid==''||(this.formData.i_isbankcharges===0&&this.formData.vc_bank_account=='')||this.formData.f_pay==0||this.formData.f_rate==0){
                    this.$message.warning('请填写必需项')
                }else{
                    if(this.formData.i_id==0){
                        this.savePayment()
                    }else{
                        this.formData.i_cid=this.formData.i_khid
                        this.formData.vc_cname=this.formData.vc_khname
                        this.updateHistoryPayment()
                    }
                    this.disabled=true
                }

            },
            cancel(){
                this.$emit('close')
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gblist=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changegb(){
                return
                this.formData.vc_bank_account='';
                this.formData.f_pendingamount='';
                this.yhzhList=[]
                if(this.formData.i_gsid){
                    this.formData.vc_gsname=this.gsList.find(gs=>gs.i_id==this.formData.i_gsid).vc_name;
                    this.getAccountByGsid()
                    if(this.formData.i_khid&&this.formData.vc_bank_account&&this.formData.i_bzid) {
                        this.getPendingAmounts()
                    }
                }
            },
            async savePayment(){
                let param=this.formData;
                let res=await API.savePayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            async updateHistoryPayment(){
                let param={
                    i_id:this.formData.i_id,
                    i_cid:this.formData.i_cid,
                    i_gsid:this.formData.i_gsid,
                    vc_gsaccount:this.formData.vc_gsaccount,
                    vc_cname:this.formData.vc_cname,
                    vc_name_bank:this.formData.vc_name_bank,
                    i_hpstatus:this.formData.i_hpstatus,
                    vc_type:this.formData.vc_type,
                };
                let res=await API.updateHistoryPayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>